<template>
  <div class="offline-meeting-ticket-template" theme>
    <div id="offline-meeting-ticket-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'offline-meeting',
      parts: [
        {
          elem: '#offline-meeting-ticket-content',
          htmlFile: 'ticket'
        }
      ]
    }
  }
}
</script>
